var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStroke = function SvgStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M2 5.476C1.114 7 1.405 13.5 2 14.524 3 16.244 8 19 10 19s7.142-3 8-4.476.858-7.573 0-9.048C17.142 4 12 1 10 1S2.886 3.951 2 5.476"
  })));
};
export { SvgStroke as ReactComponent };
export default __webpack_public_path__ + "8b39b78c62219f11ed2303b878563f89.svg";